import { useEffect, useState, useContext } from "react";
import { Link } from "react-router-dom";
import iconSprite from "bootstrap-italia/dist/svg/sprite.svg";
import Repo from "../../Utility/Repo";
import ModalComponent from "../../Components/ModalComponent";

function ShowSubscriptionGeneralStatus(props) {
  const [newSubscriprionList, setNewSubscriprionList] = useState();

  useEffect(() => {
    Repo.getSubscriptionNewList(props.apiToken)
      .then((response) => {
        setNewSubscriprionList(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  return (
    <>
      <div>
        <h1>Iscrizioni</h1>
        <div className="clearfix col-lg-8 py-lg-2">
          <p>
            {" "}
            Di seguito le iscrizioni nuove arrivate raggruppate per intervento
          </p>
        </div>
        <table className="table table-hover">
          <thead>
            <tr>
              <th scope="col">Intervento</th>
              <th scope="col">Categoria</th>
              <th scope="col" style={{ textAlign: "center" }}>
                Iscrizioni
              </th>
              <th scope="col"></th>
            </tr>
          </thead>
          <tbody>
            {newSubscriprionList &&
              newSubscriprionList.length > 0 &&
              newSubscriprionList.map((item, index) => (
                <tr key={index}>
                  <td>{item.annuncementName}</td>
                  <td>{item.serviceName}</td>
                  <td style={{ textAlign: "center" }}>
                    {item.subscriptionNew && item.subscriptionNew > 0 ? (
                      <span>
                        <span
                          className="badge p-2"
                          style={{ backgroundColor: "#2e58a6" }}
                        >
                          <a className="text-white"> {item.subscriptionNew} </a>
                        </span>
                      </span>
                    ) : (
                      <span></span>
                    )}
                  </td>
                  <td style={{ textAlign: "right" }}>
                    <Link
                      to={
                        "/lista_interventi/dettaglio_intervento?id=" +
                        item.annuncementId
                      }
                    >
                      <button
                        className="btn btn-outline-primary p-1"
                        data-toggle="tooltip"
                        data-placement="top"
                        title="Dettaglio"
                      >
                        <svg className="icon icon-primary">
                          <use href={`${iconSprite}#it-search`} />
                        </svg>
                      </button>
                    </Link>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </>
  );
}

export default ShowSubscriptionGeneralStatus;
